import { JDSModalDesktopInternalProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSModalDesktopInternalProps>
  ): React.FC<JDSModalDesktopInternalProps> =>
  (props: JDSModalDesktopInternalProps) => {
    return (
      <Component
        {...{
          ...props,
          _hasCta: Boolean(props.primaryCTA || props.secondaryCTA)
        }}
      />
    );
  };
